import { ICustomer } from 'shared/domain/entities';

const onlyDigits = (value?: string | null) => value?.replace(/\D/g, '') ?? '';

export default function needsGuardianValidation(
  customer: ICustomer | null,
  confirmedGuardianDocument: string | null,
) {
  if (!customer || customer.minorityStatus === 'ADULT') return false;

  const { guardian } = customer;

  if (guardian?.isDataStoneValidated !== false) return false;

  if (!confirmedGuardianDocument) return true;

  return (
    onlyDigits(guardian.document) !== onlyDigits(confirmedGuardianDocument)
  );
}
